<script lang="ts">
    export let text: string;
</script>

{#if text}
    <button class="abbreviation" on:click>{text}</button>
{/if}


<style>
    .abbreviation {
        display: block;
        text-align: center;
        background-color: #98c8f8;
        border-radius: 4px;
        font-weight: bold;
        cursor: pointer;
        min-width: 27px;
        padding:2px;
        border:0;
        font-size: 11px;
    }
</style>
